import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import KaraokeContainer from "../../../../../edu_lms/components/Game/Karaoke/KaraokeContainer";

const Karaoke = ({ activity, bookId }) => {
	return (
		<GameContainer data={activity}>
			<KaraokeContainer data={activity} />
		</GameContainer>
	);
};

export default Karaoke;
